<template>
	<v-container class="px-12 pb-0 p-relative" fluid>
		<!--    Filtros -->
		<v-row class="mb-0 mx-0">
			<v-container class="d-flex justify-start align-stretch pa-0" fluid>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label ">Produtor</span>
					<v-text-field outlined dense v-model="nmProdutor" :loading="loading" clearable
					              @click:clear="pesquisar()" color="#2BC1B6" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label ">UEP</span>
					<v-text-field outlined dense v-model="nrUnidadeExploracao" :loading="loading" clearable
					              @click:clear="pesquisar()"
					              color="#2BC1B6" v-mask="'########'" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex class="pt-0 mr-1">
					<span class="filtros-label text-no-wrap">Qt. mínima de vazio sanitário</span>
					<v-text-field outlined dense v-model="qtVazioSanitario" :loading="loading" clearable
					              @click:clear="pesquisar()"
					              color="#2BC1B6" @keydown.enter="pesquisar()" />
				</v-flex>
				<v-flex shrink  class="pt-0 ma-0 d-flex justify-center align-center">
					<v-btn elevation="0" color="#2BC1B6" height="40" class="btn-buscar align-self-center" dark
					       @click="pesquisar()">
						Buscar
					</v-btn>
				</v-flex>
				<v-flex shrink class="pt-0 d-flex justify-center align-center">
					<novo-lote-destino-dialog :addLoteDestinoDialog.sync="addLoteDestinoDialog">
						<template v-slot:activator="{ on }">
							<v-btn elevation="0" color="#2BC1B6" height="40" class="btn-buscar align-self-center ml-4" dark
							       @click="addLoteDestinoDialog = true">
								Adicionar Lote
							</v-btn>
						</template>
					</novo-lote-destino-dialog>
				</v-flex>
			</v-container>
		</v-row>
		<!--    Cards   -->
		<v-row class="mb-8" v-if="loading">
			<v-col v-for="n in 18" :key="n" cols="12" md="4" lg="3" xl="2">
				<v-sheet min-height="270">
					<v-skeleton-loader type="image" />
				</v-sheet>
			</v-col>
		</v-row>
		<v-row class="mb-0" v-if="listaLotesDestino.length > 0">
			<v-virtual-scroll
					bench="3"
					:items="chunkedLotes"
					item-height="384"
					min-height="400"
					max-height="680"
					min-width="700"
					width="100%"
			>
				<template v-slot="{ item }">
					<v-row class="ma-0">
						<v-col v-for="(card) in item" :key="card['idPlanejamentoAlojamentoLoteDestino']" cols="12" md="4" lg="3"
						       xl="2">
							<pre-alojamento-card :item="card" />
						</v-col>
					</v-row>
				</template>
			</v-virtual-scroll>
		</v-row>

		<!--  Estado sem creches -->
		<alert-sem-dados-para-etapa titulo="Sem lotes para pré-alojar" style="min-height: 420px;"
	                              sub-titulo="Favor adicionar lotes" v-else  />


		<v-container class="d-flex justify-center align-start">
			<v-pagination class="pb-0"
			              v-model="page"
			              :length="totalPages"
			              :total-visible="7"
			></v-pagination>
			<!--			<div style="width: 50px">-->
			<!--				<v-select  v-model="itensPagina" class="pa-0" :items="[24, 48]"-->
			<!--				          @change="verificaPaginacao()"></v-select>-->
			<!--			</div>-->
		</v-container>
    <div class="qt-vazio-sanitario-infobox">
      <div class="infobox-card elevation-2">
        Quantidade total de vazio sanitário: <span>{{qtTotalDiasVazio}}</span> dias
      </div>
    </div>
	</v-container>
</template>

<script>
import {mask} from "vue-the-mask";
import PreAlojamentoCard from "./PreAlojamentoCard";
import NovoLoteDestinoDialog from "./NovoLoteDestinoDialog";
import AlertSemDadosParaEtapa from "./AlertSemDadosParaEtapa";
import moment from "moment";
import {MODELS} from "../../resources";
import {mapState, mapActions, mapMutations} from "vuex";

export default {
	name: "PreAlojamento",
	directives: {mask},
	components: {PreAlojamentoCard, NovoLoteDestinoDialog, AlertSemDadosParaEtapa},
	data: () => ({
		addLoteDestinoDialog: false,
		nmProdutor: '',
		nrUnidadeExploracao: null,
		qtVazioSanitario: null,
		queryFiltros: {
			nmProdutor: '',
			nrUnidadeExploracao: null,
			qtVazioSanitario: null
		},
		page: 1,
		itensPagina: 48,
		totalPages: 1
	}),
	computed: {
		...mapState("planejamentoAlojamento", {
			listaLotesDestino: "listaLotesDestinoPreAlojamento",
			loading: "loadingLoteDestinoPreAlojamento",
      qtTotalDiasVazio: "qtTotalDiasVazio",
		}),
		chunkedLotes() {
			let array = this.listaLotesDestino
			if (!array) return []

			const queryFiltros = this.queryFiltros

			if (queryFiltros.nmProdutor)
				array = array.filter(lote => lote.nmProdutor.toLowerCase().startsWith(queryFiltros.nmProdutor.toLowerCase()))

			if (queryFiltros.nrUnidadeExploracao > 0)
				array = array.filter(lote => parseInt(lote.nrUnidadeExploracao) === parseInt(queryFiltros.nrUnidadeExploracao))

			if (queryFiltros.qtVazioSanitario > 0)
				array = array.filter(lote => queryFiltros.qtVazioSanitario <= lote.qtVazioSanitario)

			this.totalPages = Math.ceil(array.length / this.itensPagina)
			this.verificaPaginacao()

			let totalChunks = [];
			let chunkLength = 1;

			switch (this.$vuetify.breakpoint.name) {
				case 'md':
					chunkLength = 3;
					break;
				case 'lg':
					chunkLength = 4;
					break;
				case 'xl':
					chunkLength = 6;
					break;
			}

			if (chunkLength <= 0) {
				return array;
			}
			//Paginate arrays
			const startIndex = (this.page - 1) * this.itensPagina
			const endIndex = startIndex + this.itensPagina > array.length ? array.length : startIndex + this.itensPagina

			array = array.slice(startIndex, endIndex)

			// Loop through the data and divide it into chunks
			for (let i = 0; i < array.length; i += chunkLength) {
				totalChunks.push(array.slice(i, i + chunkLength));
			}

			// Return the chunks of data
			return totalChunks;
		},
	},
	methods: {
		...mapActions("planejamentoAlojamento", ["ActLoadListaLoteDestinoPreAlojamento"]),
		...mapMutations("planejamentoAlojamento", ["mtChangeListaLoteDestinoPreAlojamento", "mtChangeListaLoteDestinoAlojamento"]),
		alterarPreAlojamento() {
			const lotesSelecionados = this.listaLotesDestino.filter((lote) => lote.blPreAlojado === true)

			this.$axios.put(`/planejamento-alojamento-lote-destino/${this.$route.params.id}/editar-pre-alojamentos/`,
					lotesSelecionados)
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						if (res.data[0].data.length === lotesSelecionados.length)
							this.$store.commit("setSnack", {type: "success", msg: 'Lotes pré-alojados!'})
						else
							this.$store.commit("setSnack", {type: "error", msg: 'Houve um erro ao Selecionar os Lotes'})
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
					.finally(() => {
						if (this.planejamentoAlojamento.cdStatusPlanejamentoAlojamento === 1) {
							this.$emit('proximaEtapa')
							this.esconderBtn()
						} else {
							this.preAlojarBtn()
						}
					})
		},
		limparFiltros() {
			this.queryFiltros = {
				nmProdutor: null,
				nrUnidadeExploracao: null,
				qtVazioSanitario: null
			}
		},
		pesquisar() {
			this.queryFiltros = {
				nmProdutor: this.nmProdutor,
				nrUnidadeExploracao: this.nrUnidadeExploracao,
				qtVazioSanitario: this.qtVazioSanitario
			}
		},
		esconderBtn() {
			this.$emit('update:btnConfirmar', {
				disable: true,
				texto: '',
				acao: false,
				acaoType: ''
			})
		},
		preAlojarBtn() {
			this.$emit('update:btnConfirmar', {
				disable: false,
				texto: 'Confirmar',
				acao: false,
				acaoType: 'preAlojarLotes',
			})
		},
		verificaPaginacao() {
			if (this.totalPages > 0 && this.page > this.totalPages) this.page = this.totalPages
		},
	},
	mounted() {
		this.ActLoadListaLoteDestinoPreAlojamento(this.$route.params.id)

		this.preAlojarBtn()
		this.limparFiltros()
	},
	watch: {
		'btnConfirmar.acao'(acao) {
			if (acao && this.btnConfirmar.acaoType === 'preAlojarLotes') this.alterarPreAlojamento()
		}
	},
	props: {
		btnConfirmar: {
			disable: true,
			texto: '',
			acao: false,
			acaoType: ''
		},
		planejamentoAlojamento: {}
	},
}
</script>

<style scoped lang="scss">
.filtros-label {
    text-align: left;
    font: normal normal normal 10px/13px Roboto;
    letter-spacing: 0;
    color: #7B9596;
    opacity: 1;
}

.v-skeleton-loader:first-child :first-child {
    height: 270px;
}

.btn-buscar {
    margin-bottom: 2px;
    height: 40px;
}

.qt-vazio-sanitario-infobox {
  position: sticky;
  bottom: 36px;
  left: 0;
  right: 0;
  display: inline-table;
}

.infobox-card {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #799596;

  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 8px;

  span {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.5px;
    color: #35565B;
  }
}
</style>